import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'User',
    initialState: {
        id: null,
        name: null,
        token: null,
        completed: null,
        role: 'user'
    },
    reducers: {
        login(state, action) {
            const token = sessionStorage.getItem('token');
            if (token !== '') {
                sessionStorage.setItem('token', '');
            }
            sessionStorage.setItem('token', action.payload.token);
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.token = action.payload.token;
            state.completed = action.payload.completed;
            state.role = action.payload.role;
        },
        logoutReducer(state) {
            state.id = null;
            state.name = null;
            state.token = null;
            state.completed = null;
            state.role = 'user';
        },
    }
});

export const { login, logout } = userSlice.actions;

export default userSlice.reducer;